import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Observable } from "rxjs";
import { ApisService } from '../../services/apis.service';
import { ElectronService } from '../../services/electron.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-auth-callback',
  templateUrl: './auth-callback.component.html',
  styleUrls: [
    './auth-callback.component.scss'
  ]
})
export class AuthCallbackComponent implements OnInit {
  isLoading: Observable<boolean>;
  isElectron: Boolean = this.electronService.isElectron();

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private apiService: ApisService,
    private electronService: ElectronService,
    private notification: ToastrService
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      const exchangeToken = params['exchange_token'];

      if (exchangeToken) {
        this.apiService.retrieveToken(exchangeToken).subscribe(
          res => {
            this.apiService.changeUserData(res);
            this.apiService.setHeaders(res.access_token);
            if(!this.isElectron) {
              this.apiService.saveInSession(res);
            }
            this.router.navigate(['']);
          },
          err => {
            this.notification.error(err.error.error, 'Authentication');
          }
        )
      } else {
        this.router.navigate(['login']);
      }
    });
  }
}
